
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_392v4_66",
  "button": "awsui_button_vjswe_392v4_70",
  "variant-normal": "awsui_variant-normal_vjswe_392v4_132",
  "disabled": "awsui_disabled_vjswe_392v4_150",
  "variant-primary": "awsui_variant-primary_vjswe_392v4_157",
  "variant-link": "awsui_variant-link_vjswe_392v4_182",
  "variant-icon": "awsui_variant-icon_vjswe_392v4_207",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_392v4_232",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_392v4_259",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_392v4_284",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_392v4_309",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_392v4_338",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_392v4_363",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_392v4_388",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_392v4_418",
  "variant-control-group-action-validation": "awsui_variant-control-group-action-validation_vjswe_392v4_518",
  "button-no-text": "awsui_button-no-text_vjswe_392v4_522",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_392v4_526",
  "full-width": "awsui_full-width_vjswe_392v4_529",
  "button-compact": "awsui_button-compact_vjswe_392v4_546",
  "icon-left": "awsui_icon-left_vjswe_392v4_572",
  "icon-right": "awsui_icon-right_vjswe_392v4_577",
  "icon": "awsui_icon_vjswe_392v4_572",
  "link": "awsui_link_vjswe_392v4_596",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_392v4_596"
};
  